export default {
  pushTemplate: "PushTemplate",
  addpushTemplate: "AddPushTemplate",
  editpushTemplate: "EditPushTemplate",
};
